/**
 * @features/dashboard/components/widgets/RecentItemsList.jsx
 * ----------------------------------------------------------
 * Compact vertical list of recent items (properties, leads, projects).
 * Generic — accepts a renderer for each item so the same widget powers
 * every role.
 *
 *   <RecentItemsList
 *     title="Recently Viewed"
 *     items={items}
 *     renderItem={(p) => <Link to={`/property/${p.id}`}>{p.title}</Link>}
 *     emptyHint="No properties yet — start exploring."
 *     viewAllTo="/account/recent"
 *   />
 */

import React from "react";
import { Link } from "react-router-dom";

export function RecentItemsList({
  title,
  items = [],
  renderItem,
  emptyHint = "Nothing here yet.",
  viewAllTo,
  testid,
}) {
  return (
    <div
      className="bg-white border border-[#E4E4E7] rounded-sm"
      data-testid={testid || "recent-items-list"}
    >
      {title && (
        <div className="flex items-center justify-between px-4 pt-3 pb-2 border-b border-[#F4F4F5]">
          <h3 className="font-heading text-[13px] uppercase tracking-[0.1em] font-semibold text-[#09090B]">
            {title}
          </h3>
          {viewAllTo && items.length > 0 && (
            <Link
              to={viewAllTo}
              className="text-[12px] font-semibold text-[#0055FF] hover:underline underline-offset-4"
              data-testid="recent-items-view-all"
            >
              View all →
            </Link>
          )}
        </div>
      )}
      {items.length === 0 ? (
        <div className="px-4 py-8 text-center text-[12px] text-[#A1A1AA]">{emptyHint}</div>
      ) : (
        <ul className="divide-y divide-[#F4F4F5]">
          {items.map((item, i) => (
            <li key={item.id || i} className="px-4 py-3" data-testid="recent-item-row">
              {renderItem(item, i)}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
